"use client";
import { useSearchParams } from "next/navigation";
import { useEffect } from "react";

import { storeUTMInCookies } from "@/lib/utm-tracker";
import { usePathname } from "@/i18n/routing";

export const UTMCaptureClient = () => {
  const pathname = usePathname();
  const searchParams = useSearchParams();

  useEffect(() => {
    if (typeof window === "undefined") return;

    storeUTMInCookies();
  }, [pathname, searchParams]);

  return null;
};
